import { Component, OnInit, ViewChild, ElementRef, Renderer2, Pipe, Inject } from '@angular/core';
//import { Http, ResponseContentType } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { NgbModule, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';
import { AgGridModule, AgGridNg2 } from 'ag-grid-angular';
import { NgxSpinnerService } from 'ngx-spinner';
// import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

// import { FormGroup, FormControl } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { CpiHeader } from '../../model/CPI';
import { InspectionService } from '../../services/inspection.service'
import { AuthService } from '../../services/auth.service'

import {
  NgbDateStruct, NgbCalendar,
  NgbDatepicker,
  NgbInputDatepicker,
  NgbDateAdapter,
  NgbDateParserFormatter
} from '@ng-bootstrap/ng-bootstrap';
import { NgModel } from "@angular/forms";
import { Subscription } from 'rxjs';
import * as JSZip from 'jszip';

const now = new Date();

const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
  one && two && two.year === one.year && two.month === one.month && two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day < two.day : one.month < two.month : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day > two.day : one.month > two.month : one.year > two.year;


@Component({
  selector: 'app-inspection, ngbd-datepicker-range, ngbd-datepicker-popup, ngbd-modal-basic',
  templateUrl: './inspection.component.html',
  styleUrls: ['./inspection.component.css']
})

export class InspectionComponent implements OnInit {
  cpiHeaderList: CpiHeader[];
  //cpiImage:
  loading = true;
  photosDetail = [];
  photoFolderID = "photo";  //TODO: Udpate the filename of .zip when download photo
  totalPhoto = 0;
  startDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  hoveredDate: NgbDateStruct;
  fromDate: any;
  toDate: any;
  defaultFromDate: any;
  defaultToDate: any;
  model: any;
  private _subscription: Subscription;
  private _selectSubscription: Subscription;
  @ViewChild("d") input: NgbInputDatepicker;
  @ViewChild(NgModel) datePick: NgModel;
  @ViewChild('myRangeInput') myRangeInput: ElementRef;
  @ViewChild('cpiGrid') cpiGrid: AgGridNg2;

  isHovered = date =>
    this.fromDate && !this.toDate && this.hoveredDate && after(date, this.fromDate) && before(date, this.hoveredDate)
  isInside = date => after(date, this.fromDate) && before(date, this.toDate);
  isFrom = date => equals(date, this.fromDate);
  isTo = date => equals(date, this.toDate);

  closeResult: string;

  user: any;

  //Ag-Grid
  gridApi;
  defaultColDef = { editable: true };


  columnDefs = [
    // {
    //   headerName: 'ID', field: 'Id', width: 80,
    //   floatingFilterComponentParams: { suppressFilterButton: true }
    // },
    {
      headerName: 'Type', field: 'inspectionType', width: 80, checkboxSelection: true, //editable: true, 
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Job No.', field: 'jobNo', width: 100,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Plant Type', field: 'plantDescriptionEng', width: 120,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Model', field: 'model', width: 120,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Check on Site', field: 'checkOnSite', width: 120,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Serial No.', field: 'serialNo', width: 150,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Plant No', field: 'plantNo', width: 120,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'NRMM label', field: 'nrmmLabel', width: 120,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'RPE Name', field: 'certIssueBy', width: 150,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'RPE No.', field: 'registerNo', width: 120,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'RPE Cert No.', field: 'rpeCertNo', width: 120, 
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Owner', field: 'owner', width: 120,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Hirer', field: 'equipmentUser', width: 120,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Inspector', field: 'inspector', width: 120,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Inspection Date', field: 'inspectionDate', width: 120,
      valueFormatter: dateFormatter,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Expiry Date', field: 'expiryDate', width: 120,
      valueFormatter: dateFormatter,
      floatingFilterComponentParams: { suppressFilterButton: true }
    }
  ];

  rowData: any;

  //   columnDefs = [
  //     {headerName: 'Make', field: 'make' },
  //     {headerName: 'Model', field: 'model' },
  //     {headerName: 'Price', field: 'price'}
  // ];

  // rowData = [
  //     { make: 'Toyota', model: 'Celica', price: 35000 },
  //     { make: 'Ford', model: 'Mondeo', price: 32000 },
  //     { make: 'Porsche', model: 'Boxter', price: 72000 }
  // ];
  //End: Ag-Grid

  dtOptions: DataTables.Settings = {};


  constructor(private inspectionService: InspectionService,
    private AuthService: AuthService,
    calendar: NgbCalendar, element: ElementRef,
    private renderer: Renderer2, private _parserFormatter: NgbDateParserFormatter,
    private modalService: NgbModal,
    private http: HttpClient,
    private spinner: NgxSpinnerService
    //  private modalService: ModalService
  ) {
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
    this.defaultFromDate = this.fromDate;
    this.defaultToDate = this.toDate;
  }

  // ngOnInit() {
  //   this.AuthService.getUserSession()
  //   .subscribe(data => {
  //       this.user = data.slice(0);
  //       if (this.user.length > 0) {
  //           this.refreshData();
  //       }
  //   });

  //   // this.inspectionService.getCPIList()
  //   //   .subscribe(data => {
  //   //     this.rowData = data.slice(0);
  //   //   });

  //   // //this.rowData = this.inspectionService.getCPIList();

  //   // this.getCPIList();
  //   // //alert('123' + this.getCPIList());

  //   // this.dtOptions = {
  //   //   pagingType: 'full_numbers',
  //   //   pageLength: 10
  //   // };

  //   this.startDate = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
  //   this.maxDate = { year: now.getFullYear() + 1, month: now.getMonth() + 1, day: now.getDate() };
  //   this.minDate = { year: now.getFullYear() - 1, month: now.getMonth() + 1, day: now.getDate() };

  // }

  ngOnInit() {
    this.refreshData();

    this.startDate = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
    this.maxDate = { year: now.getFullYear() + 1, month: now.getMonth() + 1, day: now.getDate() };
    this.minDate = { year: now.getFullYear() - 1, month: now.getMonth() + 1, day: now.getDate() };

  }

  refreshData() {
    this.inspectionService.getCPIList()
      .subscribe(data => {
        this.rowData = data.slice(0);
      });

    //this.rowData = this.inspectionService.getCPIList();

    this.getCPIList();
    //alert('123' + this.getCPIList());

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
  }

  getCPIList(): void {
    this.inspectionService.getCPIList()
      .subscribe(data => this.cpiHeaderList = data.slice(0));
    //.subscribe(data => this.cpiHeaderList = data.slice(0, 50));
    this.loading = false;
  }

  //#region button: Download CPI/SPI
  getSelectedRows() {
    const selectedNodes = this.cpiGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data);
    const selectedDataStringPresentation = selectedData.map(node => node.Id).join(', '); //+ ' ' + node.inspectionDate
    this.downloadReport(selectedDataStringPresentation);
    //alert(`Selected nodes: ${selectedDataStringPresentation}`);
  }

  downloadReport(Id): void {
    this.spinner.show();

    this.inspectionService.downloadReport(Id)
      .subscribe(data => {
        
        saveAs(data, 'report.xlsx')

        this.spinner.hide();
      }),
      error => console.log('Error downloading the file.'),
      () => console.log('Completed file download.');
  }

  //Export Excel
  exportGrid() {
    // Default range means the grid is showing the full list (API path uses "null").
    const fromDate = this.fromDate == this.defaultFromDate
      ? 'null'
      : this._parserFormatter.format(this.fromDate);
    const toDate = this.toDate == this.defaultToDate
      ? 'null'
      : this._parserFormatter.format(this.toDate);

    this.spinner.show();
    this.inspectionService.downloadCPIList(fromDate, toDate)
      .subscribe(
        data => {
          saveAs(data, 'report.xlsx');
          this.spinner.hide();
        },
        error => {
          console.log('Error downloading the file.', error);
          this.spinner.hide();
        }
      );
  }


  //#endregion

  // checkPhotoExist() {
  //   const selectedNodes = this.cpiGrid.api.getSelectedNodes();
  //   const selectedData = selectedNodes.map(node => node.data);

  //   const selectedDataIdList = selectedData.map(node => node.Id);

  //   const selectedDataDetail = [];

  //   var totalNumberOfPhotos = 0; //TODO:

  //   for (var i = 0; i < selectedDataIdList.length; i++) {
  //     var newSelectedDataDetail = { id: selectedDataIdList[i], numberOfPhotos: 0, getAllDone: false, photoList: [] };
  //     selectedDataDetail.push(newSelectedDataDetail);
  //   }
  //   selectedDataDetail.forEach(detail => {
  //     //console.log(detail.id);
  //     //**get detail of this folder
  //     this.inspectionService.getCPIImageList(detail.id)
  //       .subscribe(photoContent => {

  //         detail.numberOfPhotos = photoContent.length;
  //         totalNumberOfPhotos += detail.numberOfPhotos;
  //       })
  //   });
  // }

  //getCPIImage(Id): void {
  getCPIImage(): void {
    this.photosDetail = [];
    var noPhotoPrompt = false;
    //get selected folder 
    const selectedNodes = this.cpiGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map(node => node.data);

    const selectedDataIdList = selectedData.map(node => node.Id);
    const selectedDataIdList2 = selectedData.map(node => node.Id).join(', ');
    console.log("selectedDataIdList2: " + selectedDataIdList2);

    var totalNumberOfPhotos = 0;

    this.inspectionService.getCPIImageListByHeaderList(selectedDataIdList2)
      .subscribe(photoList => {
        console.log("photoList.Length: " + photoList.length);
        if (photoList.length == 0) {
          console.log("photoList: " + photoList);
          console.log("photoList.Length: " + photoList.length);
          alert("No Photo can be found");
        }
        else {
          console.log("Download Photo");
          const selectedDataDetail = [];
          for (var i = 0; i < selectedDataIdList.length; i++) {
            // var newSelectedDataDetail = { id: selectedDataIdList[i], numberOfPhotos: 0, getAllDone: false, photoList: [] };
            var newSelectedDataDetail = { id: selectedDataIdList[i], numberOfPhotos: 0, photoList: [] };
            selectedDataDetail.push(newSelectedDataDetail);
          }

          //console.log('selectedDataIdList.length ' + selectedDataIdList.length);

          selectedDataDetail.forEach(detail => {
            console.log(detail.id);
            //**get detail of this folder
            this.inspectionService.getCPIImageList(detail.id)
              .subscribe(photoContent => {
                //console.log(photoContent)
                console.log('photoContent.length ' + photoContent.length);

                detail.numberOfPhotos = photoContent.length;

                //**get photos in each folder
                photoContent.forEach(photo => {
                  this.inspectionService.getCPIImage(detail.id, photo.fileName.substring(0, photo.fileName.indexOf('.')))
                    .subscribe(photoContentString => {
                      var newPhoto = { checked: false, content: '', contentOnly: '', photoFolder: detail.id, fileName: photo.fileName };
                      newPhoto.content = 'data:image/jpeg;base64,' + photoContentString;
                      newPhoto.contentOnly = photoContentString;
                      detail.photoList.push(newPhoto);
                      //**make sure all http request done
                      if (detail.photoList.length == detail.numberOfPhotos) {
                        console.log("detail.photoList.length: " + detail.photoList.length)
                        //console.log("detail.numberOfPhoto: " + detail.numberOfPhoto)
                        //detail.getAllDone = true;

                        totalNumberOfPhotos += detail.photoList.length;
                        console.log('totalNumberOfPhotos: ' + totalNumberOfPhotos);

                        this.photosDetail.push(detail.photoList);
                        // console.log("this.photosDetail.length: " + this.photosDetail.length)
                        // console.log("selectedDataIdList.length: " + selectedDataIdList.length)

                        //**wait until all data retrieval is done
                        //if (this.photosDetail.length == selectedDataIdList.length) {
                        if (photoList.length == totalNumberOfPhotos)
                          this.downloadPhotos();
                        //}
                      }
                    });
                });
              });
          });
        }
      })
  }

  //   const selectedDataStringPresentation = selectedData.map(node => node.Id).join(', '); //+ ' ' + node.inspectionDate
  //   this.inspectionService.getCPIImageList(selectedDataStringPresentation)

  //     //this.inspectionService.getCPIImageList(selectedDataStringPresentation)
  //     .subscribe(photoContent => {
  //       //console.log(photoContent)
  //       photoContent.forEach(photo => {
  //         //console.log(photo)
  //         var Id = selectedDataStringPresentation;
  //         var newPhoto = { checked: false, content: '', contentOnly: '', photoFolder: Id, fileName: photo.fileName };
  //         console.log("CPI Id: " + Id)
  //         console.log(newPhoto.fileName)
  //         //console.log(photo.fileName.substring(0, photo.fileName.indexOf('.')))
  //         this.inspectionService.getCPIImage(newPhoto.photoFolder, newPhoto.fileName.substring(0, photo.fileName.indexOf('.')))
  //           .subscribe(photoContentString => {
  //             newPhoto.content = 'data:image/jpeg;base64,' + photoContentString;
  //             newPhoto.contentOnly = photoContentString;
  //           });
  //         console.log(newPhoto);
  //         this.photosDetail.push(newPhoto);
  //       });
  //       //console.log('data:image/jpeg;base64,' + photo)

  //       // var photo = photos;
  //       // for (let photo of photos) {
  //       //   console.log(photo.content)
  //       //   photo.imageData = 'data:image/jpeg;base64,' + photo.content;

  //       // }
  //     });
  // }


  // this.photoService.getPhotos(this.entityId)
  //   .subscribe(photos => {
  //       this.photos = photos;
  //       for (let photo of this.photos) {
  //           photo.imageData = 'data:image/png;base64,' + photo.content;
  //       }
  //   });
  // onChange(result: Date): void {
  //   console.log('onChange: ', result);
  // }


  onDateSelection(date: NgbDateStruct) {
    let parsed = '';
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && after(date, this.fromDate)) {
      this.toDate = date;
      // this.model = `${this.fromDate.year} - ${this.toDate.year}`;
      this.input.close();
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
    if (this.fromDate) {
      parsed += this._parserFormatter.format(this.fromDate);
    }
    if (this.toDate) {
      parsed += ' - ' + this._parserFormatter.format(this.toDate);
    }

    this.renderer.setProperty(this.myRangeInput.nativeElement, 'value', parsed);
    ///alert(this._parserFormatter.format(this.fromDate));
    if (this.fromDate && this.toDate) {
      this.refreshCPIList(this._parserFormatter.format(this.fromDate), this._parserFormatter.format(this.toDate))
    }

  }

  // refreshCPIList(fromDate, toDate) {
  //   alert("From DAte: " + fromDate + " To Date: " + toDate)
  //   this.inspectionService.getCPIListByInspectionDate(fromDate, toDate)
  //     .subscribe(data => this.rowData = data.slice(0));
  //     console.log(this.rowData);
  //   this.loading = false;
  // }

  refreshCPIList(fromDate, toDate) {
    this.inspectionService.getCPIListByInspectionDate(fromDate, toDate)
      .subscribe(data => {
        this.cpiHeaderList = data.slice(0);
        this.rowData = data.slice(0);
      });
    this.loading = false;
  }




  //Image Dialog
  open(content) {
    //var temp = new JSzip();
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
      this.closeResult = 'Closed with: ${result}';
    }, (reason) => {
      this.closeResult = 'Dismissed ${this.getDismissReason(reason)}';
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return 'with: ${reason}';
    }
  }

  checkPhoto(photo) {
    photo.checked = !photo.checked;
    console.log(photo);
  }

  downloadPhotos(): void {

    var zip = new JSZip();
    // var zipFilename = this.photoFolderID + ".zip";
    var zipFilename = "Photos.zip";
    // var zipFilename = "CPI SPI Inspection Photos.zip";

    this.photosDetail.forEach(photoFolder => {
      if (true) {
        photoFolder.forEach(photo => {
          //if(photo.checked == true){  //TODO: Download Selected Photo
          //console.log('start download:',photo.contentOnly);
          var base64str = photo.contentOnly;

          // decode base64 string, remove space for IE compatibility
          var binary = atob(base64str.replace(/\s/g, ''));
          var len = binary.length;
          if (len > 0) {
            var buffer = new ArrayBuffer(len);
            var view = new Uint8Array(buffer);
            for (var i = 0; i < len; i++) {
              view[i] = binary.charCodeAt(i);
            }
            var blob = new Blob([view], { type: 'image/jpeg' });

            //Download single file without Zip
            // var url = window.URL.createObjectURL(blob);
            // var a = document.createElement('a');
            // document.body.appendChild(a);
            // a.setAttribute('style', 'display: none');
            // a.href = url;
            // a.download = photo.fileName;
            // a.click();
            // window.URL.revokeObjectURL(url);
            // a.remove(); 

            //zip.file(photo.fileName, blob, { binary: true });
            zip.folder(photo.photoFolder).file(photo.fileName, blob, { binary: true });
          }
        });
      }
    });

    zip.generateAsync({ type: "blob" })
      .then(function (blob) {
        saveAs(blob, zipFilename);
      });
  }
  // onGridReady(params) {
  //   this.gridApi = params.api;
  //   this.gridColumnApi = params.columnApi;

  //   this.http
  //     .get(
  //       "https://raw.githubusercontent.com/ag-grid/ag-grid/master/packages/ag-grid-docs/src/olympicWinnersSmall.json"
  //     )
  //     .subscribe(data => {
  //       this.rowData = data;
  //     });
  // }
}

//Formatter
function dateFormatter(params) {
  // console.log(params.value);
  // console.log(params.value.substring(8, 10));
  // console.log(params.value.substring(5, 7));
  // console.log(params.value.substring(0, 4));

  //var dateInJS = new Date(params.value.substring(0, 4), parseInt(params.value.substring(5, 7)) - 1, params.value.substring(8, 10));
  var year = params.value.substring(0, 4);
  var month = params.value.substring(5, 7);
  var day = params.value.substring(8, 10);

  // console.log(dateInJS);
  // console.log(year);
  // console.log(month);
  // console.log(day);

  return (year + '-' + month + '-' + day);
  //return params.value;

}